import { apiRequest } from "../../../../shared/lib/api";

export type OrganizerStatisticsPeriod =
  | "all"
  | "current_year"
  | "last_30"
  | "last_90"
  | "custom";

export type OrganizerStatisticTopItem = {
  id: string | number;
  label: string;
  value: number;
} | null;

export type OrganizerStatisticsPoint = {
  label: string;
  value: number;
};

export type OrganizerStatisticsByType = {
  type: "challenge" | "super8" | "poco" | "tournament";
  completedEvents: number;
  totalRegistrations: number;
  averageParticipants: number;
  revenueCents: number;
};

export type OrganizerStatistics = {
  scope: {
    type: "organizer" | "all";
    organizerUserId: number | null;
  };
  period: {
    code: OrganizerStatisticsPeriod;
    dateFrom: string | null;
    dateTo: string | null;
  };
  totals: {
    completedEvents: number;
    futureEvents: number;
    uniqueAthletes: number;
    totalRegistrations: number;
    soldOutEvents: number;
    canceledEvents: number;
    revenueCents: number;
    averageAthletesPerEvent: number;
    mostPopularCategory: string;
  };
  byType: OrganizerStatisticsByType[];
  internalRanking: {
    mostParticipations: OrganizerStatisticTopItem;
    mostTitles: OrganizerStatisticTopItem;
    mostRecurring: OrganizerStatisticTopItem;
    mostRegisteredCategory: OrganizerStatisticTopItem;
    eventWithMostRegistrations: OrganizerStatisticTopItem;
  };
  charts: {
    registrationsByMonth: OrganizerStatisticsPoint[];
    revenueByMonth: OrganizerStatisticsPoint[];
    eventsByMonth: OrganizerStatisticsPoint[];
    categories: OrganizerStatisticsPoint[];
  };
};

export type OrganizerStatisticsQuery = {
  period: OrganizerStatisticsPeriod;
  dateFrom?: string;
  dateTo?: string;
  organizerUserId?: number | null;
};

export function getOrganizerStatistics(
  token: string,
  query: OrganizerStatisticsQuery,
) {
  const params = new URLSearchParams();
  params.set("period", query.period);
  if (query.dateFrom) params.set("dateFrom", query.dateFrom);
  if (query.dateTo) params.set("dateTo", query.dateTo);
  if (query.organizerUserId) {
    params.set("organizerUserId", String(query.organizerUserId));
  }
  return apiRequest<OrganizerStatistics>(
    `/api/organizer/statistics?${params.toString()}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
}
